import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { loadOrg } from './actions/load-org';
import { loadApplicationStatusSubscriptions } from '../application-status-subscription/actions/load-application-status-subscriptions';
import {
  applicationStatusSubscriptionsStateForOrgIdSelector,
  applicationStatusSubscriptionsSubscriberMapForOrgIdSelector,
} from '../application-status-subscription/application-status-subscription-selector';
import { orgSelector } from '../reducers/org-selectors';
import { usersForOrgIdSelector } from '../reducers/user-selectors';

import { ApplicantStatusSubscriptionsTable } from './applicant-status-subscriptions-table';

type ApplicantStatusNotificationsTableProps = {
  orgId: number;
};

// Shared code with employee-notifications and week-in-review-notifications
export const ApplicantStatusSubscriptions = ({ orgId }: ApplicantStatusNotificationsTableProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadApplicationStatusSubscriptions({ orgId }));
    dispatch(loadOrg(orgId));
  });

  const users = useSelector((state: any) => usersForOrgIdSelector(state, orgId));
  const org = useSelector((state: any) => orgSelector(state, orgId));
  const subscriptionMap = useSelector((state: any) =>
    applicationStatusSubscriptionsSubscriberMapForOrgIdSelector(state, orgId),
  );
  const subscriptionState = useSelector((state: any) =>
    applicationStatusSubscriptionsStateForOrgIdSelector(state, orgId),
  );

  if (!users || !org || !subscriptionState || subscriptionState.loading) {
    return null;
  }

  return (
    <ApplicantStatusSubscriptionsTable org={org} users={users} subscriptionMap={subscriptionMap} />
  );
};
